import React, { useState } from "react";
import { useAdmin } from "@/context/AdminContext";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Lock } from "lucide-react";
import { toast } from "sonner";

const AdminLogin = () => {
    const { login } = useAdmin();
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!password) return;
        setSubmitting(true);
        try {
            await login(password);
            toast.success("Authenticated");
            navigate("/admin");
        } catch (err) {
            toast.error("Invalid password");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div data-testid="admin-login-page" className="min-h-screen bg-[#0B0E14] flex items-center justify-center p-6">
            <div className="bs-card p-8 md:p-12 max-w-md w-full">
                <div className="flex items-center gap-3 mb-6">
                    <ShieldCheck className="w-8 h-8 text-[#004466]" />
                    <div>
                        <div className="font-chivo text-[10px] tracking-[0.32em] uppercase text-[#004466]">
                            Restricted
                        </div>
                        <div className="font-anton text-2xl uppercase tracking-wide text-white">
                            Admin Login
                        </div>
                    </div>
                </div>
                <p className="font-body text-sm text-slate-400 mb-6">
                    Enter the admin password to access the dashboard.
                </p>
                <form onSubmit={handleSubmit} className="space-y-4" data-testid="admin-login-form">
                    <div>
                        <label className="bs-label">Password</label>
                        <div className="relative">
                            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                data-testid="admin-password-input"
                                className="bs-input pl-11"
                                placeholder="••••••••"
                                autoFocus
                            />
                        </div>
                    </div>
                    <button
                        type="submit"
                        disabled={submitting}
                        data-testid="admin-login-submit"
                        className="btn-primary w-full justify-center disabled:opacity-60"
                    >
                        {submitting ? "Authenticating..." : "Access Dashboard"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
